import type { A2uiComponentEntry } from 'types/space';

export interface GridPosition {
  x: number;
  y: number;
  width: number;
  height: number;
}

const GRID_COLS = 12;

/**
 * The next free row for a newly-placed component (EAINT-844 Phase F4, "next free row, width 6"):
 * one row below the lowest occupied `y + height` across every component that already carries a
 * `gridPosition`. Components with no `gridPosition` are ignored — they render via the adapter's
 * own index-based fallback (`spaceGridAdapter.tsx`), not a value this function can reason about.
 */
export function nextFreeGridPosition(
  components: A2uiComponentEntry[],
  width = 6,
  height = 4
): GridPosition {
  const maxY = components.reduce((max, entry) => {
    const gp = entry.gridPosition as Partial<GridPosition> | undefined;
    if (!gp || typeof gp.y !== 'number' || typeof gp.height !== 'number') return max;
    return Math.max(max, gp.y + gp.height);
  }, 0);

  return { x: 0, y: maxY, width: Math.min(width, GRID_COLS), height };
}
